import React, { useMemo, useState } from "react";
import "../../../styles/trainer-member/member-profile.css";
import { memberProfileTabs } from "./tmeMocksData";
import MemberFitnessProfileLogs from "./MemberFitnessProfileLogs";
import MemberBCALogs from "./MemberBCALogs";
import ThreedayTrialHistory from "../../pt/three-day-trial/ThreedayTrialHistory";
import MembershipHistory from "./MembershipHistory";
import MemberCheckinLogs from "../../pt-trials/common/MemberCheckinLogs";
import WorkoutLogs from "../../pt-trials/common/WorkoutLogs";
import DetailedLogs from "../DetailedLogs";
import TMEPTTrackDetails from "./TMEPTTrackDetails";
import TMEChartAnalysis from "../tme-analysis/TMEChartAnalysis";
import TMEAttendanceAnalysis from "../tme-analysis/TMEAttendanceAnalysis";
import TMENutritionAnalysis from "../tme-analysis/tme-nutrition-analysis/TMENutritionAnalysis";

const MemberAllProfiles = ({ userInfoData, rowData }) => {
  const [activeTab, setActiveTab] = useState(
    memberProfileTabs[0]?.value || "fitness-profile"
  );

  const transformedClickValues = useMemo(() => {
    if (!rowData) return rowData;

    const { user_id, ...restData } = rowData;

    return {
      ...restData,
      userId: user_id,
    };
  }, [rowData]);

  return (
    <>
      <div className="lms-v2-tabs-container payrole-tabs-container member-profile-tabs mt15">
        {memberProfileTabs.map((tab, idx) => (
          <div
            key={idx}
            className={`lms-v2-tab${
              activeTab === tab.value ? " lms-v2-tab-active" : ""
            }`}
            onClick={() => setActiveTab(tab.value)}
            style={{ cursor: "pointer" }}
          >
            {tab.icon}

            <span>{tab.label}</span>
          </div>
        ))}
      </div>

      {activeTab === "member-profile" && (
        <TMEPTTrackDetails
          activeTab={activeTab}
          rowData={rowData}
          userInfoData={userInfoData}
        />
      )}

      {activeTab === "fitness-profile" && (
        <MemberFitnessProfileLogs
          activeTab={activeTab}
          rowData={rowData}
          userInfoData={userInfoData}
        />
      )}

      {activeTab === "bca-profile" && (
        <MemberBCALogs
          activeTab={activeTab}
          rowData={rowData}
          userInfoData={userInfoData}
        />
      )}

      {activeTab === "pt-trial" && (
        <ThreedayTrialHistory
          activeTab={activeTab}
          rowData={rowData}
          userInfoData={userInfoData}
        />
      )}

      {activeTab === "membership" && (
        <MembershipHistory
          activeTab={activeTab}
          rowData={rowData}
          userInfoData={userInfoData}
        />
      )}

      {activeTab === "checkins" && (
        <MemberCheckinLogs
          activeTab={activeTab}
          clickValues={transformedClickValues}
          userInfoData={userInfoData}
        />
      )}

      {activeTab === "workouts" && (
        <WorkoutLogs
          clickValues={transformedClickValues}
          userInfoData={userInfoData}
        />
      )}

      {activeTab === "trainer-rating" && (
        <DetailedLogs
          from="trainer_rating_logs"
          rowData={rowData}
          userInfoData={userInfoData}
        />
      )}

      {activeTab === "member-progress" && (
        <TMEChartAnalysis rowData={rowData} userInfoData={userInfoData} />
      )}

      {activeTab === "attendance" && (
        <TMEAttendanceAnalysis rowData={rowData} userInfoData={userInfoData} />
      )}

      {activeTab === "nutrition" && (
        <TMENutritionAnalysis rowData={rowData} userInfoData={userInfoData} />
      )}
    </>
  );
};

export default MemberAllProfiles;
